import { TPlatformState } from '../../types/platform';

const defaultState: TPlatformState = null;

export function platformReducer(state: TPlatformState = defaultState): TPlatformState {
  return state;
}
